import {
    httpStoreProjectMainPathologies,
    HttpStoreProjectMainPathologiesOptions
} from '@/features/projects/http/projects.http'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'

export const useStoreProjectMainPathologies = ({
    urlParams,
    options
}: {
    urlParams: HttpStoreProjectMainPathologiesOptions['urlParams']
    options?: UseMutationOptions<unknown, unknown, HttpStoreProjectMainPathologiesOptions['payload']>
}) => useMutation({mutationFn: payload => httpStoreProjectMainPathologies({urlParams, payload}), ...options})
